import { Text, View, Image } from '@react-pdf/renderer';

const Hobbies = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>
			<View style={styles.skills}>
				{data?.map((res: any) => (
					<View key={res} style={styles.skillsBox}>
						<Text style={styles.skillsText}>{res}</Text>
					</View>
				))}
				{/* <Image style={styles.hobbiesIcon} src={IMAGE_PATHS.hobbyIcon1} />
				<Image style={styles.hobbiesIcon} src={IMAGE_PATHS.hobbyIcon2} />
				<Image style={styles.hobbiesIcon} src={IMAGE_PATHS.hobbyIcon3} />
				<Image style={styles.hobbiesIcon} src={IMAGE_PATHS.hobbyIcon4} />
				<Image style={styles.hobbiesIcon} src={IMAGE_PATHS.hobbyIcon5} /> */}
			</View>
		</View>
	);
};

export default Hobbies;
